import React from "react";
import { InviteErrorPage } from "./InviteErrorPage";

/**
 * Thin wrapper preserved for existing call sites and test data-testids.
 * New error states render via {@link InviteErrorPage} directly.
 */
export const ExpiredInvitePage: React.FC = () => (
  <InviteErrorPage code="INVITE_TOKEN_EXPIRED" />
);
